'use client';

import Script from 'next/script';
import useScrollTrack from 'helpers/hooks/gtm/useScrollTrack';
import useTrackPageRoute from 'helpers/hooks/gtm/useTrackPageRoute';

export const GoogleAnalyticsTracking = ({ gtmId }: { gtmId: string }) => {
  const GA_MEASUREMENT_ID = gtmId ?? process.env.NEXT_PUBLIC_GTM_ID;

  useTrackPageRoute(); // track SPA route changes
  useScrollTrack(); // track page scrolling

  if (!GA_MEASUREMENT_ID) return null;

  return (
    <>
      {/* GTM Script */}
      <Script id="gtm-script" strategy="afterInteractive">
        {`
              (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
              new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
              j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
              'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
              })(window,document,'script','dataLayer','${GA_MEASUREMENT_ID}');
            `}
      </Script>

      {/* Manual GTM <noscript> fallback */}
      <noscript>
        <iframe
          title="GTM"
          src={`https://www.googletagmanager.com/ns.html?id=${GA_MEASUREMENT_ID}`}
          height="0"
          width="0"
          style={{ display: 'none', visibility: 'hidden' }}
        ></iframe>
      </noscript>
    </>
  );
};
